import { gql } from '@apollo/client';

export const PAGE_FILTER_CNH_LIST_VIEW = gql`
  query {
    PageFilterCnhListView {
      quickFilters {
        name
        value
      }
      fleetIndicators {
        name
        value
      }
      modelYears {
        name
        value
      }
      distributorCodes {
        distributorCode
        distributorName
        countryName
        countryCode
        exportIndicator
        brandCodes {
          brandCode
          brandName
          countries {
            countryCode
            countryName
            regions {
              regionCode
              regionName
              dealers {
                dealerCode
                dealerName
              }
              salesSeries {
                salesSeriesName
              }
              salesSeriesExport {
                exportSeriesName
              }
            }
          }
        }
      }
    }
  }
`;
